import React, { useCallback, useState, useEffect, useRef } from "react";
import { Box, Button, TextField, TextareaAutosize, Typography, setRef } from "@mui/material";
import * as tf from "@tensorflow/tfjs";
// import * as posenet from "@tensorflow-models/posenet";
import * as poseDetection from "@tensorflow-models/pose-detection";
import { v4 as uuidv4 } from "uuid";

let timeBasedDict = {};

const saveJson = (data, filename) => {
  const jsonString = JSON.stringify(data, null, 2);
  const blob = new Blob([jsonString], { type: "application/json" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = `${filename}.json`;
  link.click();
  URL.revokeObjectURL(link.href);
};

const GestureExtraction = () => {
  const videoRef = useRef(null);
  const [filename, setFilename] = useState(uuidv4());
  const [videoSrc, setVideoSrc] = useState(null);
  // "https://sso.reality-connect.tech/video/fitness-3min-white10.mp4"
  // Set the WebGL backend for TensorFlow.js

  // MARK: may consider to turn it back on, if multiple webgl can be register in differnet page
  // tf.setBackend("webgl");

  useEffect(() => {
    if (videoSrc) {
      estimatePosesOnVideo();
      const handleVideoEnd = () => {
        // console.log(timeBasedDict);
        saveJson(timeBasedDict, filename);
      };
      const videoElement = videoRef.current;
      videoElement.addEventListener("ended", handleVideoEnd);
      return () => {
        videoElement.removeEventListener("ended", handleVideoEnd);
      };
    }
  }, [videoSrc]);

  async function estimatePosesOnVideo() {
    await tf.setBackend("webgl"); // Set the backend to 'webgl' for better performance
    await tf.ready(); // Wait for TensorFlow.js to initialize the backend
    // const videoElement = document.getElementById("video");
    const videoElement = videoRef.current;
    // Load the PoseNet model
    // const net = await poseDetection.load();
    const detector = await poseDetection.createDetector(poseDetection.SupportedModels.MoveNet, {
      modelType: poseDetection.movenet.modelType.SINGLEPOSE_LIGHTNING,
    });
    // Create a canvas element for drawing poses
    const canvas = document.createElement("canvas");
    document.body.appendChild(canvas);
    const ctx = canvas.getContext("2d");
    // Play the video
    // Process each video frame
    function processFrame() {
      // const imageScaleFactor = 0.5;
      const imageScaleFactor = 1.0;
      const outputStride = 16;
      // Resize the canvas to match the video dimensions
      canvas.width = videoElement.videoWidth;
      canvas.height = videoElement.videoHeight;
      // Draw the current video frame on the canvas
      ctx.drawImage(videoElement, 0, 0);
      // Estimate poses on the canvas image
      detector.estimatePoses(canvas, imageScaleFactor, false, outputStride).then((poses) => {
        // if (videoElement.paused) {
        //   videoElement.play();
        // }
        // Process the detected poses
        const currentTime = videoRef.current.currentTime;
        poses.forEach((pose) => {
          // Access pose keypoints, scores, etc.
          timeBasedDict[`${currentTime.toFixed(1)}`] = {
            // keypoints: pose.keypoints,
            leftWrist: pose.keypoints[9],
            rightWrist: pose.keypoints[10],
            leftShoulder: pose.keypoints[5],
            rightShoulder: pose.keypoints[6],
            canvasSize: { width: canvas.width, height: canvas.height },
          };
          // console.log(timeBasedDict);
          // console.log(pose.keypoints);
          // console.log({ width: canvas.width, height: canvas.height });
        });
        // Request the next frame
        requestAnimationFrame(processFrame);
      });
    }
    // Start processing video frames
    requestAnimationFrame(processFrame);
  }

  return (
    <Box>
      <input
        type="file"
        accept="video/*"
        onChange={(evt) => {
          const file = evt.target.files[0];
          const videoURL = URL.createObjectURL(file);
          setFilename(file.name.replace(/\.[^/.]+$/, ""));
          setVideoSrc(videoURL);
        }}
      />

      <video
        // autoPlay
        muted
        playsInline
        controls
        ref={videoRef}
        src={videoSrc}
      ></video>
    </Box>
  );
};

export { GestureExtraction };

// const { createFFmpeg, fetchFile } = require("@ffmpeg/ffmpeg");
// const tf = require("@tensorflow/tfjs");
// const posenet = require("@tensorflow-models/posenet");
// require("@tensorflow/tfjs-node");

// async function extractFramesFromVideo(videoPath) {
//   const ffmpeg = createFFmpeg({ log: true });

//   // Load the ffmpeg library
//   await ffmpeg.load();

//   // Read video file
//   await ffmpeg.FS("readFile", videoPath);

//   // Extract frames from the video using ffmpeg
//   await ffmpeg.run("-i", videoPath, "frames.png");

//   // Read the extracted frames as a buffer
//   const data = ffmpeg.FS("readFile", "frames.png");

//   // Cleanup temporary files
//   await ffmpeg.FS("unlink", "frames.png");
//   await ffmpeg.FS("unlink", videoPath);

//   // Return the frames as a buffer
//   return data.buffer;
// }

// async function estimatePosesOnVideoFrames() {
//   const imageScaleFactor = 0.5;
//   const outputStride = 16;

//   // Load the PoseNet model
//   const net = await posenet.load({
//     architecture: "MobileNetV1",
//     outputStride: outputStride,
//     multiplier: 0.75,
//   });

//   const videoPath = "../../public/video/fitness-3min-white10.mp4";

//   // Extract frames from the video
//   const framesBuffer = await extractFramesFromVideo(videoPath);

//   // Load the frames as a TensorFlow tensor
//   const framesTensor = tf.node.decodeImage(framesBuffer);

//   // Estimate poses on the frames tensor
//   const poses = await net.estimatePoses(
//     framesTensor,
//     imageScaleFactor,
//     false,
//     outputStride
//   );

//   // Process the detected poses
//   poses.forEach((pose) => {
//     // Access pose keypoints, scores, etc.
//     console.log(pose.keypoints);
//   });
// }

// // Call the function to start pose estimation on the video frames
// estimatePosesOnVideoFrames();
